import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import notify from "../../../components/notify";
import { useDeleteData } from "../../../hooks/useDeleteData";
import i18n from "../../../i18n/i18n";

// ✅ WHEELS

export const getAllWheels = createAsyncThunk(
  "/wheelSlice/getAllWheels",
  async () => {
    try {
      const response = await useGetData(`/wheel`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);
export const getSpinStatus = createAsyncThunk(
  "/wheelSlice/getSpinStatus",
  async () => {
    try {
      const response = await useGetData(`/wheel/spin-status`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);
export const getMyRewards = createAsyncThunk(
  "/wheelSlice/getMyRewards",
  async () => {
    try {
      const response = await useGetData(`/wheel/rewards`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);
export const rewardOfSpin = createAsyncThunk(
  "/wheelSlice/rewardOfSpin",
  async ({data}, {rejectWithValue}) => {
    try {
      // console.log("data",data);
      const response = await useInsertData(`/wheel/spin`,data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
         notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"), "error");
      } else {
         notify(error.response?.data, "error");
        return rejectWithValue(error.response?.data, "error");
      }
    }
  },
);

export const getOneWheel = createAsyncThunk(
  "/wheelSlice/getOneWheel",
  async (id) => {
    try {
      const response = await useGetData(`/wheel/${id}`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);

export const editWheel = createAsyncThunk(
  "/wheelSlice/editWheel",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await useUpdateData(`/wheel/${id}`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data, "error");
        return rejectWithValue(error.response?.data);
      }
    }
  },
);

export const addWheel = createAsyncThunk(
  "/wheelSlice/addWheel",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`/wheel`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data?.message, "error");
        return rejectWithValue(error.response?.data?.message);
      }
    }
  },
);

export const deleteWheel = createAsyncThunk(
  "/wheelSlice/deleteWheel",
  async (id) => {
    try {
      const response = await useDeleteData(`/wheel/${id}`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);